import { useState } from "react";
import siteConfig from "site-config";

import { API_STATES, createAuthHeader } from "models/new/helpers";
import { TAPIResponse } from "models/new/types";
import { fetchJSON } from "lib/fetch";

export type TValidateAgainstExistingMerchantPayload = {
    brandID: string;
    body: {
        credentials: {
            account_number?: string;
            username?: string;
            password?: string;
            api_key?: string;
        };
    };
};

export type TValidateAgainstExistingMerchantError = { code: number; message: string };

export type TValidateAgainstExistingMerchantResponse = {};

type TValidateAgainstExistingMerchantHookParams = {};

type TValidateAgainstExistingMerchantHookResponse<TValidateAgainstExistingMerchantHookParams, Response> = {
    (params?: TValidateAgainstExistingMerchantHookParams): Response & {
        enableMerchant: (params: TValidateAgainstExistingMerchantPayload) => void;
    };
};

export const useValidateAgainstExistingMerchant: TValidateAgainstExistingMerchantHookResponse<
    TValidateAgainstExistingMerchantHookParams,
    TAPIResponse<TValidateAgainstExistingMerchantResponse, TValidateAgainstExistingMerchantError>
> = (_params: TValidateAgainstExistingMerchantHookParams) => {
    const [state, setState] = useState<
        TAPIResponse<TValidateAgainstExistingMerchantResponse, TValidateAgainstExistingMerchantError>
    >(API_STATES.default);
    const APIStates = API_STATES.getStates(setState);

    const enableMerchant = (params: TValidateAgainstExistingMerchantPayload) => {
        const URL = `${siteConfig.api}/lightspeed-b2b/api/v1/merchant-enablement/brands/${params.brandID}`;

        APIStates.pending();

        fetchJSON<TValidateAgainstExistingMerchantResponse>(URL, {
            method: "PUT",
            body: JSON.stringify(params.body),
            headers: createAuthHeader({ bypassEnvironmentCheck: true }),
        })
            .then(APIStates.success)
            .catch((error) => APIStates.error({ message: error }));
    };

    return {
        data: state.data,
        error: state.error,
        isLoading: state.isLoading,
        loaded: state.loaded,
        enableMerchant,
    };
};
